import { render, staticRenderFns } from "./ButtonsAdd.vue?vue&type=template&id=0951d0e4&scoped=true&"
import script from "./ButtonsAdd.vue?vue&type=script&lang=js&"
export * from "./ButtonsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0951d0e4",
  null
  
)

export default component.exports